<template>
    <Head titulo="Te Escuchamos" />
    <div class="hero-img-overlay " style="background-image: url('/img/hero-secretarias-direcciones.png');">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Te Escuchamos</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="bloque-general bloque-contacto">
        <div class="container">
            <div class="row justify-content-between">
                <div class="col-md-7" v-if="!sendit">
                    <h4 class="encabezado-simple" style="margin-top: 0;">Queremos escucharte, en este buzón ciudadano podrás indicarnos tus peticiones o dudas sobre la información de esta página municipal. Ingresa tus datos y nosotros nos comunicaremos contigo.
                    </h4>
                    <form @submit.prevent="recaptcha">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group" :class="{ 'not-valid': form.errors.nombre }">
                                    <label for="form-nombre">Nombre(s) <span class="asterisc">*</span></label>
                                    <input v-model="form.nombre" id="form-nombre" type="text" class="form-control" required="">
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group" :class="{ 'not-valid': form.errors.apellidos }">
                                    <label for="form-apellidos">Apellidos <span class="asterisc">*</span></label>
                                    <input v-model="form.apellidos" id="form-apellidos" type="text" class="form-control" required="">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group" :class="{ 'not-valid': form.errors.email }">
                                    <label for="form-correo">Correo electrónico <span class="asterisc">*</span></label>
                                    <input v-model="form.email" id="form-correo" type="text" class="form-control" required="">
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group" :class="{ 'not-valid': form.errors.telefono }">
                                    <label for="form-telefono">Teléfono <span class="asterisc">*</span></label>
                                    <input v-model="form.telefono" id="form-telefono" type="text" class="form-control" required="">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group" :class="{ 'not-valid': form.errors.mensaje }">
                                    <label for="form-mensaje">Describa el motivo de su petición o dudas <span class="asterisc">*</span></label>
                                    <textarea v-model="form.mensaje" class="form-control" id="form-mensaje" rows="6" required=""></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <p style="font-size: 14px;line-height: 1.3em;">La información registrada será confidencial y será utilizada única y exclusivamente por la dependencia. Si desea conocer nuestro aviso de privacidad integral, <a href="/descargas/avisodeprivacidad.pdf" target="_blank">consulte aquí</a></p>
                            </div>
                        </div>
                        <div class="form-group-submit">
                            <div class="response-output show" v-if="form.hasErrors">
                                <p>Por favor completa los campos faltantes</p>
                                <ul>
                                    <li v-for="(error, i) in form.errors" :key="i">{{ error }}</li>
                                </ul>
                            </div>
                            <button type="submit" :disabled="form.processing">{{ (form.processing) ? 'Enviando ...' :
                                'Enviar'
                            }}</button>
                        </div>
                    </form>
                </div>

                <div class="col-md-7 text-center" v-else>
                    <div v-if="!send_error">
                        <img loading="lazy" width="99" height="87" class="bloque-form-enviado__icono" src="/img/icono-hexagono-check-dorado.svg" alt="">
                        <h1 class="bloque-form-enviado__encabezado">Tu mensaje ha sido enviado de forma exitosa.</h1>
                        <div class="bloque-form-enviado__info">
                            <p>Cada mensaje es importante para nosotros. Gracias por confiar en el Gobierno de Santiago,
                                Nuevo León.</p>
                        </div>
                        <Link href="/" class="boton-secundario boton-flecha">Regresar a la portada</Link>
                    </div>
                    <div v-else>
                        <i class="fi fi-close error text-danger"></i>
                        <h1 class="bloque-form-enviado__encabezado">Lo sentimos, ocurrió un error.</h1>
                        <div class="bloque-form-enviado__info">
                            <p>Tuvimos un error enviando tu mensaje, por favor intenta mas tarde.</p>
                        </div>
                        <Link href="/te_escuchamos" class="boton-secundario boton-flecha">Intentar de nuevo</Link>
                    </div>
                </div>

                <div class="col-md-5 col-lg-4">
                    <div class="sidebar-contacto__info">
                    <div class="queja sidebar-contacto">
                        <p class="contacto-info">
                            <h4>¿Tienes una queja de un servicio o funcionario público?</h4>
                            Si necesitas presentar alguna sugerencia, queja sobre algún trámite o servicio o queja sobre el desempeño de algún funcionario público, expone tu protesta en el siguiente botón:
                        </p>
                        <a href="/servicio/enlinea/protesta-ciudadana" class="boton-principal boton-flecha" data-v-f196ba08="">Presentar Sugerencia</a>
                    </div>
                    </div>
                    <div class="sidebar-contacto">
                        <h4 class="encabezado-simple">¡Estamos a tus órdenes!</h4>
                        <div class="sidebar-contacto__info">
                            <div class="contacto-info">
                                <div class="contacto-info__label">Dirección</div>
                                <p>Jose Mariano Abasolo 100, Santiago, 67300 Santiago, N.L.</p>
                                <a href="https://www.google.com/maps/dir/25.7642084,-100.4341074/Presidencia+Municipal+Villa+de+Santiago,+Jose+Mariano+Abasolo+100,+Santiago,+67300+Santiago,+N.L./@25.5939125,-100.4334048,11z/data=!3m1!4b1!4m17!1m6!3m5!1s0x8662cebef5f3e2d5:0xd83f90f08c1b562e!2sPresidencia+Municipal+Villa+de+Santiago!8m2!3d25.4247862!4d-100.1510703!4m9!1m1!4e1!1m5!1m1!1s0x8662cebef5f3e2d5:0xd83f90f08c1b562e!2m2!1d-100.1510703!2d25.4247862!3e0" target="_blank" class="link-ubicacion link-ubicacion--dorado">¿Cómo llegar?</a>
                            </div>
                            <div class="contacto-info">
                                <div class="contacto-info__label">Teléfono</div>
                                <a :href="'tel:' + this.$telefono" class="link-telefono-info">{{ this.$telefono }}</a>
                            </div>
                            <div class="contacto-info">
                                <div class="contacto-info__label">Correo electrónico</div>
                                <a href="mailto:atencionciudadana@santiago.gob.mx" class="link-correo">atencionciudadana@santiago.gob.mx</a>
                            </div>
                        </div>
                        <h4 class="encabezado-simple">¿Tienes una emergencia?</h4>
                        <div class="item-contacto">
                            <a href="tel:911" class="link-telefono">911</a>
                            <a href="tel:911" class="link-contacto">Emergencias</a>
                        </div>
                        <div class="item-contacto">
                            <a href="tel:8122851112" class="link-telefono">81 2285 1112</a>
                            <a href="tel:8122851112" class="link-contacto">Protección Civil</a>
                        </div>
                        <div class="item-contacto">
                            <a href="tel:8188811111" class="link-telefono">81 8881 1111</a>
                            <a href="tel:8188811111" class="link-contacto">Línea Rosa</a>
                        </div>
                        <div class="item-contacto">
                            <a href="tel:8120027848" class="link-telefono">81 2002 7848</a>
                            <a href="tel:8120027848" class="link-contacto">C4</a>
                        </div>
                        <div class="item-contacto">
                            <a href="tel:8110308541" class="link-telefono">81 1030 8541</a>
                            <a href="tel:8110308541" class="link-contacto">Defensoría Emergencia</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Head from '../../Shared/Head.vue';
import { useForm } from '@inertiajs/inertia-vue3';
import { Link } from '@inertiajs/inertia-vue3'
import { useReCaptcha } from "vue-recaptcha-v3";

export default {
    components: {
        Head, Link
    },
    props: {
        sendit: Boolean,
        send_error: Boolean,
    },
    setup() {
        const form = useForm({
            nombre: '',
            apellidos: '',
            telefono: '',
            email: '',
            mensaje: '',
            captcha_token: '',
        });

        const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()
        const recaptcha = async () => {
            await recaptchaLoaded()
            form.captcha_token = await executeRecaptcha('login')
            submit();
        }

        function submit() {
            form.post('/te_escuchamos', {
                preserveScroll: true,
                onSuccess: () => form.reset(),
            });
        }

        return {
            form, submit, recaptcha,
        }
    },
}
</script>
<style scoped>
.fi.error {
    font-size: 4rem;
    margin-bottom: 30px;
}

.asterisc {
    color: red;
    font-size: 24px;
    line-height: 0em;
}
.queja {
    padding: 1px 20px 13px;
    background: #faffa687;
    border-radius: 10px;
}
.queja h4{
    line-height: 1.5em;
    font-weight: bold;
    font-size: 18px;
}
</style>
